module.exports = __webpack_public_path__ + "static/media/backup_02.02c25627.svg";